module.exports = __webpack_public_path__ + "static/img/hezuo12.d2e6578.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/imgsrc/hezuo12.jpg
// module id = LmRz
// module chunks = 1